import { Controller } from "@hotwired/stimulus"

// Owns the taggable-entity list for the [[ ]] reference picker. Single
// responsibility: fetch the list ONCE (on connect), cache it for the page's
// life, and answer filter queries. The picker UI controller (entity-picker)
// asks this controller for matches — it never fetches itself. Multiple editors
// on one page share one cached list.
//
// Attach to an element wrapping the editor(s):
//   <div data-controller="entity-list" data-entity-list-url-value="/e.json">
export default class extends Controller {
  static values = { url: { type: String, default: "/e.json" } }

  connect() {
    this.entities = []
    this.loaded = false
    this.load()
  }

  async load() {
    try {
      const res = await fetch(this.urlValue, { headers: { Accept: "application/json" } })
      if (res.ok) {
        this.entities = await res.json()
        this.loaded = true
      }
    } catch (_e) {
      // Network failure: leave the list empty; the picker simply shows nothing.
    }
  }

  // Return up to `limit` entities whose name contains `query` (case-insensitive).
  // All entities whose name matches `query` (case-insensitive). Empty query
  // returns everything, so [[ with no input shows the full taggable list
  // (scrollable). No cap — the menu scrolls; you type to narrow it.
  search(query) {
    const q = (query || "").trim().toLowerCase()
    if (!q) return this.entities
    return this.entities.filter((e) => e.name.toLowerCase().includes(q))
  }
}
